import { PropTypes } from "prop-types";
import { StyledUserCard } from "../../../styles/StyledUserCard/StyledUserCard";
import { MoreActions } from "../../MoreActions";

export default function ParticipantUnitCard({
	data,
	color,
	openDropdowns,
	setOpenDropdowns,
	direction,
	moreActionsPosition,
	openModal,
	showOptions,
}) {
	const { id, name } = data;

	let acronym = "";
	name.split(" ").map((e, i) => {
		if (i < 2) acronym += e.split("")[0];
	});

	return (
		<StyledUserCard color={color} short={true}>
			{showOptions && openDropdowns && (
				<MoreActions
					type={`u${id}`}
					options={[
						{
							display: true,
							testId: `u${id}-delete`,
							name: "Remove participant unit",
							click: () => openModal(id),
						},
					]}
					isOpen={openDropdowns}
					setIsOpen={setOpenDropdowns}
					isDisabled={false}
					direction={direction}
					moreActionsPosition={moreActionsPosition}
				/>
			)}
			<div className="user-header">
				<div className="user-picture">
					<span>{acronym}</span>
				</div>
				<div>
					<span className="user-label">Name</span>
					<h5>{name}</h5>
				</div>
			</div>
		</StyledUserCard>
	);
}

ParticipantUnitCard.propTypes = {
	data: PropTypes.object,
	color: PropTypes.string,
	openDropdowns: PropTypes.object,
	setOpenDropdowns: PropTypes.func,
	refetch: PropTypes.func,
	direction: PropTypes.string,
	moreActionsPosition: PropTypes.string,
	openModal: PropTypes.func,
	showOptions: PropTypes.bool,
};
